import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Data.Controller.SoraCame = (function () {
  return {
    setup: function (data) {
      data.control = {
        state: {
          retained: {},
          status: null,
          revision: 0,
        },
      };
      data._update("data", data.control.state);
      setTimeout(function () {
        data._inspector(data.source.data);
      }, 0);

      // コンフィグの調整
      data.setAutoUpdate("data", false);
      data.setUpdateInterval("data", 0);
      // 自動更新時間の優先度（CameraMaster > CameraInfo）
      var update_interval;
      if (data.conf.CameraMaster && data.conf.CameraMaster.update_interval) {
        data.setAutoUpdate("CameraMaster", false);
        update_interval = data.conf.CameraMaster.update_interval;
        data.control.auto_update_master = true;
      }
      if (update_interval) {
        data.setUpdateInterval("data", update_interval);
      }
      if (data.controller_conf.request_timeout) {
        var target = ["CameraMaster", "ImageFileList", "ImageFile"];
        for (var i = 0; i < target.length; i++) {
          var ds = data.source[target[i]];
          if (ds && ds.conf.request_timeout === undefined) {
            ds.conf.request_timeout = data.controller_conf.request_timeout;
          }
        }
      }
    },
    load: function (data, id, option, force, completed, error, progress) {
      var ds = data.source[id];
      if (ds) {
        return ds.load(option, force, completed, error, progress);
      }
    },
    derive: function (data, id, option, force, completed) {
      force;
      data.load(
        "CameraMaster",
        option,
        true,
        async function (camera_master_data) {
          const ret = camera_master_data.list.map((l) => {
            return {
              config: l,
              controller: data,
            };
          });
          data.control.state.retained = ret;
          data._update(id, data.control.state);
          var target = data.source[id];
          data._inspector(target);
          for (var i = 0; i < target.inspector.completed.length; i++) {
            target.inspector.completed[i](data.retained[id]);
          }
          target.autoUpdate();
        },
        function (info, url) {
          info, url;
        }
      );
    },
    setAutoUpdate: function () {},
    setUpdateInterval: function () {},
  };
})();
/* eslint-enable */
